import React from "react";
import { Alert, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useBrand } from "../brand/BrandContext";
import { resolveTenantLegal } from "../brand/legal";

const TenantLegalNotice = () => {
  const { t } = useTranslation("common");
  const brand = useBrand();
  const legal = resolveTenantLegal(brand);
  if (!legal) {
    return null;
  }
  const lines = [
    legal.legalName && `${t("legal.legalName")}: ${legal.legalName}`,
    legal.edrpou && `${t("legal.edrpou")}: ${legal.edrpou}`,
    legal.legalAddress && `${t("legal.address")}: ${legal.legalAddress}`,
    legal.email && `${t("legal.email")}: ${legal.email}`,
    legal.phone && `${t("legal.phone")}: ${legal.phone}`,
  ].filter(Boolean);

  return (
    <Alert severity="info" sx={{ mb: 3 }}>
      <Typography fontWeight={600} sx={{ mb: 0.5 }}>
        {t("legal.carrierHeading", { name: legal.displayName })}
      </Typography>
      {lines.map((line) => (
        <Typography key={line} variant="body2">
          {line}
        </Typography>
      ))}
    </Alert>
  );
};

export default TenantLegalNotice;
